<app-data-set #dataSet defaultPresentationMode="table" [rowId]="rowId" firstColumnProperty="userFirstName">
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="workingFor"
				[defaultFilterLabel]="filterLabels.workingFor"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="companyTypeFlag ? 3 : 4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.userName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('userName')"
								data-automation-id="user-name-input"
								(ngModelChange)="dataSet.filter('userName', filterLabels.userName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.workingFor }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								data-automation-id="company-name-input"
								(ngModelChange)="dataSet.filter('companyName', filterLabels.workingFor, $event)"
							/>
						</mat-form-field>
					</div>
					@if (companyTypeFlag) {
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.clientName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('clientName')"
									data-automation-id="client-name-input-device"
									(ngModelChange)="dataSet.filter('clientName', filterLabels.clientName, $event)"
								/>
							</mat-form-field>
						</div>
					} @else {
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locationName')"
									data-automation-id="property-name-input"
									(ngModelChange)="dataSet.filter('locationName', filterLabels.propertyName, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceLocation')"
									data-automation-id="device-location-input"
									(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
								/>
							</mat-form-field>
						</div>
					}
				</div>
				@if (companyTypeFlag) {
					<div class="filter-grid" [style.--columns]="companyTypeFlag ? 3 : 4">
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.clientIDN }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('clientIDN')"
									data-automation-id="client-idn-input-device"
									(ngModelChange)="dataSet.filter('clientIDN', filterLabels.clientIDN, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.propertyName }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('locationName')"
									data-automation-id="property-name-input"
									(ngModelChange)="dataSet.filter('locationName', filterLabels.propertyName, $event)"
								/>
							</mat-form-field>
						</div>
						<div class="filter-item">
							<mat-form-field subscriptSizing="dynamic" appearance="outline">
								<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
								<input
									matInput
									[ngModel]="dataSet.filter('deviceLocation')"
									data-automation-id="device-location-input"
									(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
								/>
							</mat-form-field>
						</div>
					</div>
				}
				<div class="filter-grid" [style.--columns]="4">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.eventType }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('eventType')"
								data-automation-id="event-type-input"
								(ngModelChange)="dataSet.filter('eventType', filterLabels.eventType, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.eventStart }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('eventStart')"
								disabled
								data-automation-id="event-start-input"
								(ngModelChange)="dataSet.filter('eventStart', filterLabels.eventStart, $event)"
								[matDatepicker]="eventStartPicker"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="eventStartPicker"
								data-automation-id="event-start-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker
								#eventStartPicker
								disabled="false"
								data-automation-id="event-start-datepicker"
							></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.eventEnd }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('eventEnd')"
								disabled
								data-automation-id="event-end-input"
								(ngModelChange)="dataSet.filter('eventEnd', filterLabels.eventEnd, $event)"
								[matDatepicker]="eventEndPicker"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="eventEndPicker"
								data-automation-id="event-end-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker
								#eventEndPicker
								disabled="false"
								data-automation-id="event-end-datepicker"
							></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  Should use dropdown -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.endVisitType }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('endVisitType')"
								data-automation-id="end-visit-type-input"
								(ngModelChange)="dataSet.filter('endVisitType', filterLabels.endVisitType, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		@if (this.canGenerateEventHistoryReport) {
			<div *appActionGroup>
				<app-data-set-action-button
					label="Download"
					i18n-label="@@deviceAccessHistory-downloadReport"
					(click)="this.isDownloadReportDisabled ? null : generateEventHistoryReport()"
					data-automation-id="download-button"
					[isDisabled]="this.isDownloadReportDisabled"
				></app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (
				loadingService.isLoading(getDeviceEventHistoryLoadingKey) ||
				loadingService.isLoading(getEventHistoryReportLoadingKey) ||
				!finishedLoadingInitData
			) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSortActive="eventStart"
				matSortDirection="desc"
				matSort
				[hidden]="
					loadingService.isLoading(getDeviceEventHistoryLoadingKey) ||
					loadingService.isLoading(getEventHistoryReportLoadingKey) ||
					!finishedLoadingInitData
				"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="userName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-user">User</th>
					<td mat-cell *matCellDef="let row">
						@if (row.entityRelationship?.childUser) {
							{{ row.entityRelationship?.childUser?.firstName }}
							{{ row.entityRelationship?.childUser?.lastName | emptyData }}
						}
						@if (!row.entityRelationship?.childUser) {
							{{ row.userFirstName }} {{ row.userLastName | emptyData }}
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-workingFor">Working For</th>
					<td mat-cell *matCellDef="let row">{{ row.entityRelationship?.parentEntity?.name | emptyData }}</td>
				</ng-container>

				<!-- Company type 'care' then below two columns will display otherwise not load in UI : -->
				@if (companyTypeFlag) {
					<ng-container matColumnDef="clientName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-clientName">
							Client Name
						</th>
						<td mat-cell *matCellDef="let row">{{ row.clientInformation?.clientName ?? '- - -' }}</td>
					</ng-container>
					<ng-container matColumnDef="clientIDN">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-clientIDN">Client IDN</th>
						<td mat-cell *matCellDef="let row">{{ row.clientInformation?.clientIDN ?? '- - -' }}</td>
					</ng-container>
				}

				<ng-container matColumnDef="locationName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-propertyName">
						Property Name
					</th>
					<td mat-cell *matCellDef="let row">{{ row.location?.name ?? '- - -' }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-deviceLocation">
						Device Location
					</th>
					<td mat-cell *matCellDef="let row">{{ row.installationLocation?.name ?? '- - -' }}</td>
				</ng-container>

				<ng-container matColumnDef="eventType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-eventType">Event Type</th>
					<td
						mat-cell
						*matCellDef="let row"
						[attr.data-automation-id]="'device-event-history-event-type-' + rowId(row)"
					>
						{{ row.eventName | eventTypeFormat: row.deviceRemovalAccessOptionsEnabled : row.metadata }}
					</td>
				</ng-container>

				<ng-container matColumnDef="eventStart">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-eventStart">Event Start</th>
					<td mat-cell *matCellDef="let row">
						<div class="date-time-container">
							<span>
								{{
									row.utcStartDate
										? (row.utcStartDate
												| date
													: 'mediumDate'
													: timeZoneService.utcOffset(row.utcStartDate, row.location?.timezone ?? 'UTC')) +
											', ' +
											(row.utcStartDate
												| date
													: 'shortTime'
													: timeZoneService.utcOffset(row.utcStartDate, row.location?.timezone ?? 'UTC')) +
											' ' +
											(row.location?.timezone ?? 'UTC' | abbreviatedTimezone: row.utcStartDate)
										: '- - -'
								}}
							</span>
							@if (row.alarmStart === AlarmStatus.disarm) {
								<img
									src="assets/icons/icon-shield-with-x.svg"
									class="ajax-icon"
									[alt]="disarmedAlarmText"
									[title]="disarmedAlarmText"
								/>
							}
							@if (row.alarmStart === AlarmStatus.overriden) {
								<img
									src="assets/icons/icon-bell-crossed-out-orange.svg"
									class="ajax-icon bell-icon"
									[alt]="alarmOverrideText"
									[title]="alarmOverrideText"
								/>
							}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="eventEnd">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-eventEnd">Event End</th>
					<td mat-cell *matCellDef="let row">
						<div class="date-time-container">
							<span>
								{{
									row.utcEndDate
										? (row.utcEndDate
												| date
													: 'mediumDate'
													: timeZoneService.utcOffset(row.utcEndDate, row.location?.timezone ?? 'UTC')) +
											', ' +
											(row.utcEndDate
												| date
													: 'shortTime'
													: timeZoneService.utcOffset(row.utcEndDate, row.location?.timezone ?? 'UTC')) +
											' ' +
											(row.location?.timezone ?? 'UTC' | abbreviatedTimezone: row.utcEndDate)
										: '- - -'
								}}
							</span>
							@if (row.alarmEnd === AlarmStatus.arm) {
								<img
									src="assets/icons/icon-shield-checkmark-red.svg"
									class="ajax-icon"
									[alt]="armedAlarmText"
									[title]="armedAlarmText"
								/>
							}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="endVisitType">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@deviceEventHistory-endVisitType">
						End Visit Type
					</th>
					<td mat-cell *matCellDef="let row">
						{{ row.endVisitType ? (row.endVisitType | endVisitTypeFormat) : '- - -' }}
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row"></td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
